import React from 'react';
import {
  DarkBackgroundLink,
  PrimaryLink,
  SecondaryLink,
  TypographyNameLink,
} from './styles';
import { LinkProps } from './types';

const Link = (props: LinkProps) => {
  const { linkVariant, ...remain } = props;
  switch (linkVariant) {
    case 'primary':
      return <PrimaryLink {...remain} />;
      break;
    case 'secondary':
      return <SecondaryLink {...remain} />;
      break;
    case 'name':
      return <TypographyNameLink {...remain} />;
      break;
    case 'dark':
      return <DarkBackgroundLink {...remain} />;
      break;
    default:
      return <PrimaryLink {...remain} />;
  }
};

export default Link;
